import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71c4f456"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "container",
  class: "text-align-center"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("아이디")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("비밀번호 (특수문자 포함, 8자리 이상)")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("회사명")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("업체 담당자")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("연락처")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("이메일")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("사업자번호")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("사용자 구분")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("거래처")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("운송사")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("거래처&운송사")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("대한슬래그 담당자")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("등록")

import {
  IonContent,
  IonPage,
  IonItem,
  IonInput,
  IonButton,
  IonLabel,
  IonList,
  IonSelect,
  IonSelectOption
} from '@ionic/vue';
// import { chevronForwardOutline } from 'ionicons/icons';
import { users } from '@/api/services/register';
import { reactive} from 'vue';
interface Resiter {  
  id: string;
  password: string;
  company: string;
  priv: string;
  tlno: string;
  email: string;
  sano: string;
  userGubn: string;
  manager: string;
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {apply, insertApply} = users();

const form: Resiter = reactive({  
  id:'',
  password: '',
  company: '',
  priv: '',
  tlno: '',
  email:'',
  sano: '',
  userGubn: '',
  manager: ''
});


// const rules = {
//   id: { required },
//   password: { required },
//   name: { required },
//   sano: {},

// };
// const vv = useVuelidate(rules, {
//   id: toRef(form, "id"),
//   password: toRef(form, "password"),
//   name: toRef(form, "name"),
//   sano: toRef(form, "sano"),

// });

// /** 外部エラー */
// const $externalResults = ref({})
// const v$ = useVuelidate(rules, form, { $externalResults })
// /** バリデーション */
// function validate() {
//   v$.value.$validate()
// }
// /** バリデーションリセット */
// function resetValidate() {
//   v$.value.$clearExternalResults()
//   v$.value.$reset()
// }
// /** externalResults追加 */
// function addExternalResults() {
//   $externalResults.value = {
//     // keyはstateと同様のものを指定する
//     name: ['externalResults error'],
//   }
// }
// const passwordCheck =computed(() => form.passwordHasError != form.passwordConfrimHasError)

// function checkPassword() {
//       비밀번호 형식 검사(영문, 숫자, 특수문자)
//       const validatePassword = /^(?=.*[a-zA-z])(?=.*[0-9])(?=.*[$`~!@$!%*#^?&\\(\\)\-_=+]).{8,16}$/
//       if(!validatePassword.test(form.password)||form.password){
//         form.passwordHasError = true;
//         errorpassword.value ="비밀번호는 영문,숫자,특수문자조합으로 설정해야합니다."
//       }else{
//         errorpassword.value = ""
//       }
    
//     }    
// watch(form, (newValue) => {
//     checkPassword()
// });

function selectGubn(e: any) {
      form.userGubn = e.target.value;     
}
const sendApply = async () => {
  apply.id = form.id;
  apply.password = form.password;
  apply.company = form.company;
  apply.priv = form.priv;
  apply.tlno = form.tlno;
  apply.email = form.email;
  apply.sano = form.sano;
  apply.userGubn = form.userGubn;
  apply.manager = form.manager;
  await insertApply()
}

return (_ctx: any,_cache: any) => {
  const _component_app_header = _resolveComponent("app-header")!

  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_component_app_header, {
        back: "home",
        title: "회원가입"
      }),
      _createVNode(_unref(IonContent), { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(IonList), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonItem), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), { position: "floating" }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonInput), {
                      type: "text",
                      modelValue: _unref(form).id,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).id) = $event)),
                      placeholder: "아이디를 입력해주세요"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonItem), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), { position: "floating" }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonInput), {
                      type: "password",
                      modelValue: _unref(form).password,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).password) = $event)),
                      placeholder: "비밀번호를 입력해주세요"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonItem), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), { position: "floating" }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonInput), {
                      type: "text",
                      modelValue: _unref(form).company,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).company) = $event)),
                      placeholder: "회사명을 입력해주세요"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonItem), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), { position: "floating" }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonInput), {
                      type: "text",
                      modelValue: _unref(form).priv,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).priv) = $event)),
                      placeholder: "사용자명을 입력해주세요"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonItem), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), { position: "floating" }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonInput), {
                      type: "text",
                      modelValue: _unref(form).tlno,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).tlno) = $event)),
                      placeholder: "연락처를 입력해주세요"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonItem), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), { position: "floating" }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonInput), {
                      type: "email",
                      modelValue: _unref(form).email,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).email) = $event)),
                      placeholder: "이메일을 입력해주세요"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonItem), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), { position: "floating" }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonInput), {
                      modelValue: _unref(form).sano,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).sano) = $event)),
                      placeholder: "사업자번호를 입력주세요",
                      type: "tel",
                      maxlength: "12"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonItem), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), { position: "floating" }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonSelect), {
                      placeholder: "사용자 유형을 선택하세요",
                      interface: "popover",
                      value: _unref(form).userGubn,
                      onIonChange: _cache[7] || (_cache[7] = ($event: any) => (selectGubn($event)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonSelectOption), { value: "1" }, {
                          default: _withCtx(() => [
                            _hoisted_10
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonSelectOption), { value: "2" }, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonSelectOption), { value: "3" }, {
                          default: _withCtx(() => [
                            _hoisted_12
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonItem), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), { position: "floating" }, {
                      default: _withCtx(() => [
                        _hoisted_13
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonInput), {
                      type: "text",
                      modelValue: _unref(form).manager,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(form).manager) = $event)),
                      placeholder: "대한슬래그 담당자명을 입력해주세요"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonButton), {
              color: "medium",
              onClick: sendApply
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})